import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
} from "@/components/ui/alert-dialog";
import { SuccessTickIcon } from "@/assets/icons/admin";
import { Button } from "@nextui-org/react";

interface SuccessResponseDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

const SuccessResponseDialog = ({ isOpen, onClose }: SuccessResponseDialogProps) => {
    return (
        <AlertDialog open={isOpen} onOpenChange={onClose}>
            <AlertDialogContent className="w-[80%] sm:w-80 h-[40%] sm:h-80 p-0">
                <AlertDialogHeader>
                    <div className="bg-[#14142A] h-full sm:rounded-t-lg sm:rounded-b-lg">
                        <div className="flex items-center justify-center text-center p-3 mt-4">
                            <span><SuccessTickIcon /></span>
                        </div>
                        <div className="flex items-center justify-center text-center p-3">
                            <span className="text-white text-2xl font-semibold font-montserrat">Email sent successfully</span>
                        </div>
                        <div className="flex items-center justify-center text-center p-3">
                            <span className="text-white text-sm font-normal font-montserrat">Your response has been sent to the user via email.</span>
                        </div>
                        <div className={`flex items-center justify-center p-3`}>
                            <Button onClick={onClose} className="admin-common-button-gradient font-ubuntu w-[96%] rounded-md text-base text-white font-bold">
                                Close
                            </Button>
                        </div>
                    </div>
                </AlertDialogHeader>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default SuccessResponseDialog;
